import { CandidateJobMatchCard } from '../../../models/candidateJobMatchCard';
class SendAssessmentController {
    /*@ngInject*/
    constructor($rootScope, $uibModal, $timeout, $filter, moment, dateTimeUtilityService, jobMatchService, jobService, assessmentService, planService, candidateService, companyService, alertsAndNotificationsService) {
        this.$rootScope = $rootScope;
        this.$uibModal = $uibModal;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.moment = moment;
        this.dateTimeUtilityService = dateTimeUtilityService;
        this.jobMatchService = jobMatchService;
        this.jobService = jobService;
        this.assessmentService = assessmentService;
        this.planService = planService;
        this.candidateService = candidateService;
        this.companyService = companyService;
        this.alertsAndNotificationsService = alertsAndNotificationsService;
    }
    $onInit() {
        //variables
        this.companyId = this.$rootScope.userDetails.company.companyId;
        this.assessmentData = {
            jobMatchId: null,
            companyId: this.companyId,
            notes: '',
            externalNote: '',
            startDateTime: null,
            endDateTime: null,
            accessTime: null,
            reminder: 2,
            timeToComplete: null,
            //timeZoneId: null
            timeZoneName: null
        };
        this.externalNotesAction = {};
        this.sendAssessmentLabel = '';
        this.assessmentName = '';
        this.candidateJobMatch = {};
        this.accessTimePreferences = {};
        this.remindAfterDays = [];
        this.jobMatchDetailsArray = [];
        this.jobMatchesThatCanBeSentAssessment = [];
        this.jobMatchesThatCannotBeSentAssessment = [];
        this.sendAssessmentLicensePreferenceEnum = null;
        this.assessmentDetails = null;
        this.previousStateDateTime = null;
        this.assessmentsLeft;
        this.defaultReminderInterval = 0;
        //flags
        this.loadingFlag = true;
        this.savingFlag = false;
        this.isTrialPlanActive = false;
        this.isCompanyOnSoftHold = false;
        this.loadingAccessTimeOptionsFlag = false;
        this.showAccessTimeOptionsFlag = false;
        this.reminderErrorFlag = false;
        this.multipleJobMatchesFlag = false;
        this.loadingMultipleJobMatchesDataFlag = false;
        this.isStaffingCompany = false;
        this.isReminderEnabled = false;
        this.isStaffingCompany = this.companyService.isStaffingCompany();
        this.getCompanyState(() => {
            this.getCompanyPlanDetails(() => {
                this._initializeAssessmentDetails();
            });
        });
    }
    _initializeAssessmentDetails() {
        this.userId = this.$rootScope.userDetails.id;
        if (!_.isUndefined(this.jobMatchDetailsArrayString)) {
            this.multipleJobMatchesFlag = true;
            this.jobMatchDetailsArray = JSON.parse(this.jobMatchDetailsArrayString);
            this.jobMatchId = this.jobMatchDetailsArray[0].jobMatchId;
            this.candidateId = this.jobMatchDetailsArray[0].candidateId;
        }
        else {
            this.multipleJobMatchesFlag = false;
            let tempObject = {};
            tempObject.jobMatchId = this.jobMatchId;
            tempObject.candidateId = this.candidateId;
            this.jobMatchDetailsArray.push(tempObject);
        }
        if (this.multipleJobMatchesFlag) {
            this.loadingMultipleJobMatchesDataFlag = true;
            // initialize for each of the job matches
            angular.forEach(this.jobMatchDetailsArray, (val, key) => {
                val.loadingFlag = true;
                val.sendErrorType = null;
                val.sendErrorMessage = null;
                val.jobMatchData = {};
            });
            // get details for each of the job matches to be shown
            angular.forEach(this.jobMatchDetailsArray, (val, key) => {
                this.getCandidateJobMatchCardInfo(val.jobMatchId, () => {
                    val.jobMatchData = angular.copy(this.candidateJobMatch);
                    val.loadingFlag = false;
                    if (this.assessmentType == "Technical" && (val.jobMatchData.jobMatchCurrentState == 'In Tech Assessment' || val.jobMatchData.jobMatchCurrentState == 'Tech Assessment Canceled')) {
                        let sendActionInfo = _.find(val.jobMatchData.availableActions, { actionType: "SEND_TECHNICAL_ASSESSMENT" });
                        if (sendActionInfo == undefined) {
                            val.sendErrorType = 'actionNotAllowed';
                            let message = "";
                            message = val.jobMatchData.joinedInOtherJob ? 'Candidate is already in joined status in another requisition.' : (val.jobMatchData.filledInOtherJob ? 'Candidate is already in filled status in another requisition.' : '');
                            val.sendErrorMessage = " (Current status: '" + val.jobMatchData.jobMatchCurrentState + "') - " + message;
                            this.jobMatchesThatCannotBeSentAssessment.push(val);
                        }
                        else if (sendActionInfo.allowed) {
                            val.message = " (Current status: '" + val.jobMatchData.jobMatchCurrentState + "')";
                            this.jobMatchesThatCanBeSentAssessment.push(val);
                        }
                        else {
                            val.sendErrorType = 'actionNotAllowed';
                            val.sendErrorMessage = " (Current status: '" + val.jobMatchData.jobMatchCurrentState + "') - " + sendActionInfo.message;
                            this.jobMatchesThatCannotBeSentAssessment.push(val);
                        }
                    }
                    else if (this.assessmentType == "Technical" && _.find(val.jobMatchData.availableActions, { actionType: "RE_SEND_TECHNICAL_ASSESSMENT" }) !== undefined) {
                        let resendActionInfo = _.find(val.jobMatchData.availableActions, { actionType: "RE_SEND_TECHNICAL_ASSESSMENT" });
                        if (resendActionInfo.allowed) {
                            this._setResendAssessmentInfo(val);
                            this.jobMatchesThatCanBeSentAssessment.push(val);
                        }
                        else {
                            val.sendErrorType = 'actionNotAllowed';
                            val.sendErrorMessage = " (Current status: '" + val.jobMatchData.jobMatchCurrentState + "') - " + resendActionInfo.message;
                            this.jobMatchesThatCannotBeSentAssessment.push(val);
                        }
                    }
                    else if (this.assessmentType == "Value" && (val.jobMatchData.jobMatchCurrentState == 'In Value Assessment' || val.jobMatchData.jobMatchCurrentState == 'Value Assessment Canceled')) {
                        let sendActionInfo = _.find(val.jobMatchData.availableActions, { actionType: "SEND_VALUE_ASSESSMENT" });
                        if (sendActionInfo == undefined) {
                            val.sendErrorType = 'actionNotAllowed';
                            let message = "";
                            message = val.jobMatchData.joinedInOtherJob ? 'Candidate is already in joined status in another requisition' : (val.jobMatchData.filledInOtherJob ? 'Candidate is already in filled status in another requisition.' : '');
                            val.sendErrorMessage = " (Current status: '" + message + "')";
                            this.jobMatchesThatCannotBeSentAssessment.push(val);
                        }
                        else if (sendActionInfo.allowed) {
                            val.message = " (Current status: '" + val.jobMatchData.jobMatchCurrentState + "')";
                            this.jobMatchesThatCanBeSentAssessment.push(val);
                        }
                        else {
                            val.sendErrorType = 'actionNotAllowed';
                            val.sendErrorMessage = " (Current status: '" + val.jobMatchData.jobMatchCurrentState + "') - " + sendActionInfo.message;
                            this.jobMatchesThatCannotBeSentAssessment.push(val);
                        }
                    }
                    else if (this.assessmentType == "Value" && _.find(val.jobMatchData.availableActions, { actionType: "RE_SEND_VALUE_ASSESSMENT" }) !== undefined) {
                        let resendActionInfo = _.find(val.jobMatchData.availableActions, { actionType: "RE_SEND_VALUE_ASSESSMENT" });
                        if (resendActionInfo.allowed) {
                            this._setResendAssessmentInfo(val);
                            this.jobMatchesThatCanBeSentAssessment.push(val);
                        }
                        else {
                            val.sendErrorType = 'actionNotAllowed';
                            val.sendErrorMessage = " (Current status: '" + val.jobMatchData.jobMatchCurrentState + "') - " + resendActionInfo.message;
                            this.jobMatchesThatCannotBeSentAssessment.push(val);
                        }
                    }
                    else {
                        val.sendErrorType = 'wrongState';
                        val.sendErrorMessage = " is not in a valid status (Current status: '" + val.jobMatchData.jobMatchCurrentState + "').";
                        this.jobMatchesThatCannotBeSentAssessment.push(val);
                    }
                    if ((this.jobMatchesThatCanBeSentAssessment.length + this.jobMatchesThatCannotBeSentAssessment.length) == this.jobMatchDetailsArray.length) {
                        this.loadingMultipleJobMatchesDataFlag = false;
                    }
                    if (!this.loadingMultipleJobMatchesDataFlag && !this.loadingAccessTimeOptionsFlag) {
                        this.loadingFlag = false;
                    }
                }, (error) => {
                    val.loadingFlag = false;
                    this.loadingMultipleJobMatchesDataFlag = false;
                });
            });
        }
        this.assessmentData.jobMatchId = this.jobMatchId;
        this.loadingAccessTimeOptionsFlag = true;
        for (let i = 0; i <= 31; i++) {
            this.remindAfterDays.push({
                id: i,
                text: '' + i
            });
        }
        if (_.isNull(this.assessmentSendMode)) {
            this.assessmentSendMode = 'send';
        }
        switch (this.assessmentType) {
            case 'Technical':
                this.sendAssessmentLabel = 'Technical Assessment';
                this.sendAssessmentLicensePreferenceEnum = 'TECH_ASSESSMENT';
                break;
            case 'Value':
                this.sendAssessmentLabel = 'Value Assessment';
                this.sendAssessmentLicensePreferenceEnum = 'VALUE_ASSESSMENT';
                break;
        }
        this.assessmentData.notes = 'Sending ' + this.sendAssessmentLabel;
        if (this.assessmentSendMode == 'resend') {
            this.assessmentData.notes = 'Resending ' + this.sendAssessmentLabel;
        }
        if (this.notes !== "") {
            this.assessmentData.notes = this.notes;
        }
        this.candidateJobMatch = new CandidateJobMatchCard();
        this.getCandidateJobMatchCardInfo(this.jobMatchId, () => {
            if (this.isTrialPlanActive || this.isCompanyOnSoftHold) {
                this.getAvailableAssessments();
            }
            if (this.assessmentSendMode == 'resend') {
                let assessmentDetailsObject = {};
                assessmentDetailsObject.jobMatchId = this.jobMatchId;
                assessmentDetailsObject.assessmentType = this.assessmentType;
                this.assessmentService.getCandidateAssessmentDetails(assessmentDetailsObject, (data) => {
                    this.assessmentDetails = data;
                    this.assessmentDetails.isSendAssessmentFailed = this.candidateJobMatch.jobMatchCurrentState.includes("Failed");
                    if (!_.isNull(this.assessmentDetails.expiredDateTime)) {
                        this.assessmentDetails.expiredDateTime = new Date(this.assessmentDetails.expiredDateTime);
                    }
                    if (!_.isNull(this.assessmentDetails.cancelledDateTime)) {
                        this.assessmentDetails.cancelledDateTime = new Date(this.assessmentDetails.cancelledDateTime);
                    }
                    if (!_.isNull(this.assessmentDetails.completedDateTime)) {
                        this.assessmentDetails.completedDateTime = new Date(this.assessmentDetails.completedDateTime);
                    }
                    if (!_.isNull(this.assessmentDetails.sentDateTime)) {
                        this.assessmentDetails.sentDateTime = new Date(this.assessmentDetails.sentDateTime);
                    }
                    if (!_.isNull(this.assessmentDetails.suspendedDateTime)) {
                        this.assessmentDetails.suspendedDateTime = new Date(this.assessmentDetails.suspendedDateTime);
                    }
                    if (!_.isNull(this.assessmentDetails.terminatedDateTime)) {
                        this.assessmentDetails.terminatedDateTime = new Date(this.assessmentDetails.terminatedDateTime);
                    }
                    if (!_.isNull(this.assessmentDetails.testLeftDateTime)) {
                        this.assessmentDetails.testLeftDateTime = new Date(this.assessmentDetails.testLeftDateTime);
                    }
                    if (this.assessmentDetails.assessmentLinkStatus == 'Expired' && !_.isNull(this.assessmentDetails.expiredDateTime)) {
                        this.previousStateDateTime = this.assessmentDetails.expiredDateTime;
                    }
                    else if (this.assessmentDetails.assessmentLinkStatus == 'Suspended' && !_.isNull(this.assessmentDetails.suspendedDateTime)) {
                        this.previousStateDateTime = this.assessmentDetails.suspendedDateTime;
                    }
                    else if (this.assessmentDetails.assessmentLinkStatus == 'Terminated' && !_.isNull(this.assessmentDetails.terminatedDateTime)) {
                        this.previousStateDateTime = this.assessmentDetails.terminatedDateTime;
                    }
                    else if (this.assessmentDetails.assessmentLinkStatus == 'Test Left' && !_.isNull(this.assessmentDetails.testLeftDateTime)) {
                        this.previousStateDateTime = this.assessmentDetails.testLeftDateTime;
                    }
                    else if (this.assessmentDetails.assessmentLinkStatus == 'Complete' && !_.isNull(this.assessmentDetails.completedDateTime)) {
                        this.previousStateDateTime = this.assessmentDetails.completedDateTime;
                    }
                    else if (this.assessmentDetails.isSendAssessmentFailed && !_.isNull(this.assessmentDetails.sentDateTime)) {
                        this.previousStateDateTime = this.assessmentDetails.sentDateTime;
                    }
                    else {
                        this.previousStateDateTime = '';
                    }
                    this.assessmentDetails.sendAssessmentsCount = this.assessmentDetails.sendAssessmentsCount + 1;
                    this.assessmentDetails = this._setSentAssessmentsPostfix(this.assessmentDetails);
                }, (error) => {
                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                });
            }
            this.getAccessTimePreferences(() => {
                if (_.isNull(this.accessTimePreferences.timeToComplete)) {
                    // default time to complete, if it is null
                    this.accessTimePreferences.timeToComplete = 2;
                }
                if (_.isNull(this.accessTimePreferences.reminderInterval)) {
                    // default reminder interval, if it is null
                    this.accessTimePreferences.reminderInterval = 2;
                }
                this.assessmentData.reminder = this.accessTimePreferences.reminderInterval;
                this.defaultReminderInterval = this.assessmentData.reminder;
                if (this.assessmentData.reminder > 0) {
                    this.isReminderEnabled = true;
                }
                else {
                    this.defaultReminderInterval = 2;
                }
                // initialize all access time options to be false
                this.accessTimePreferences.anyTime = false;
                this.accessTimePreferences.timeBound = false;
                this.accessTimePreferences.slotWise = false;
                // TODO: remove jQuery and use data binding to set the default value.
                $('#reminderInDays').val(this.assessmentData.reminder);
                let accessTimeOptionsToShowCount = 0;
                angular.forEach(this.accessTimePreferences.accessTimeDtos, (val, key) => {
                    if (val.accessTimeLabel == 'Any Time') {
                        if (val.accessTimeEnabled && val.accessTimeValue) {
                            this.accessTimePreferences.anyTime = true;
                            accessTimeOptionsToShowCount++;
                        }
                    }
                    else if (val.accessTimeLabel == 'Time Bound') {
                        if (val.accessTimeEnabled && val.accessTimeValue) {
                            this.accessTimePreferences.timeBound = true;
                            accessTimeOptionsToShowCount++;
                        }
                    }
                    else if (val.accessTimeLabel == 'Slot Wise') {
                        if (val.accessTimeEnabled && val.accessTimeValue) {
                            this.accessTimePreferences.slotWise = true;
                            accessTimeOptionsToShowCount++;
                        }
                    }
                });
                if (accessTimeOptionsToShowCount == 0) {
                    this.showAccessTimeOptionsFlag = false;
                    // default to any time if all the options are sent as 'false'
                    this.assessmentData.accessTime = 'anyTime';
                }
                else if (accessTimeOptionsToShowCount == 1) {
                    this.showAccessTimeOptionsFlag = false;
                    if (this.accessTimePreferences.anyTime) {
                        this.assessmentData.accessTime = 'anyTime';
                    }
                    else if (this.accessTimePreferences.timeBound) {
                        this.assessmentData.accessTime = 'timeBound';
                        this._initializeDateAndTimePickersForTimeBound();
                    }
                    else if (this.accessTimePreferences.slotWise) {
                        this.assessmentData.accessTime = 'slotWise';
                        this._initializeDateAndTimePickersForSlotWise();
                    }
                }
                else if (accessTimeOptionsToShowCount > 1) {
                    this.showAccessTimeOptionsFlag = true;
                    if (this.accessTimePreferences.anyTime) {
                        this.assessmentData.accessTime = 'anyTime';
                    }
                    if (this.accessTimePreferences.timeBound) {
                        this._initializeDateAndTimePickersForTimeBound();
                    }
                    if (this.accessTimePreferences.slotWise) {
                        this._initializeDateAndTimePickersForSlotWise();
                    }
                    // default to the first available option
                    if (this.accessTimePreferences.anyTime) {
                        this.assessmentData.accessTime = 'anyTime';
                    }
                    else {
                        // time bound should be available since anyTime is not available
                        this.assessmentData.accessTime = 'timeBound';
                    }
                }
                this.loadingAccessTimeOptionsFlag = false;
                if (!this.loadingAccessTimeOptionsFlag && !this.loadingMultipleJobMatchesDataFlag) {
                    this.loadingFlag = false;
                }
                this.$timeout(() => {
                    this.reminderChanged();
                }, 500);
            });
        });
    }
    _setResendAssessmentInfo(jobMatch) {
        let assessmentDetailsObject = {};
        assessmentDetailsObject.jobMatchId = jobMatch.jobMatchId;
        assessmentDetailsObject.assessmentType = this.assessmentType;
        this.assessmentService.getCandidateAssessmentDetails(assessmentDetailsObject, (data) => {
            jobMatch.assessmentDetails = data;
            if (!_.isNull(jobMatch.assessmentDetails.expiredDateTime)) {
                jobMatch.assessmentDetails.expiredDateTime = new Date(jobMatch.assessmentDetails.expiredDateTime);
            }
            if (!_.isNull(jobMatch.assessmentDetails.cancelledDateTime)) {
                jobMatch.assessmentDetails.cancelledDateTime = new Date(jobMatch.assessmentDetails.cancelledDateTime);
            }
            if (!_.isNull(jobMatch.assessmentDetails.completedDateTime)) {
                jobMatch.assessmentDetails.completedDateTime = new Date(jobMatch.assessmentDetails.completedDateTime);
            }
            if (!_.isNull(jobMatch.assessmentDetails.sentDateTime)) {
                jobMatch.assessmentDetails.sentDateTime = new Date(jobMatch.assessmentDetails.sentDateTime);
            }
            if (!_.isNull(jobMatch.assessmentDetails.suspendedDateTime)) {
                jobMatch.assessmentDetails.suspendedDateTime = new Date(jobMatch.assessmentDetails.suspendedDateTime);
            }
            if (!_.isNull(jobMatch.assessmentDetails.terminatedDateTime)) {
                jobMatch.assessmentDetails.terminatedDateTime = new Date(jobMatch.assessmentDetails.terminatedDateTime);
            }
            if (!_.isNull(jobMatch.assessmentDetails.testLeftDateTime)) {
                jobMatch.assessmentDetails.testLeftDateTime = new Date(jobMatch.assessmentDetails.testLeftDateTime);
            }
            if (jobMatch.assessmentDetails.assessmentLinkStatus == 'Expired' && !_.isNull(jobMatch.assessmentDetails.expiredDateTime)) {
                jobMatch.previousStateDateTime = jobMatch.assessmentDetails.expiredDateTime;
            }
            else if (jobMatch.assessmentDetails.assessmentLinkStatus == 'Suspended' && !_.isNull(jobMatch.assessmentDetails.suspendedDateTime)) {
                jobMatch.previousStateDateTime = jobMatch.assessmentDetails.suspendedDateTime;
            }
            else if (jobMatch.assessmentDetails.assessmentLinkStatus == 'Terminated' && !_.isNull(jobMatch.assessmentDetails.terminatedDateTime)) {
                jobMatch.previousStateDateTime = jobMatch.assessmentDetails.terminatedDateTime;
            }
            else if (jobMatch.assessmentDetails.assessmentLinkStatus == 'Test Left' && !_.isNull(jobMatch.assessmentDetails.testLeftDateTime)) {
                jobMatch.previousStateDateTime = jobMatch.assessmentDetails.testLeftDateTime;
            }
            else if (jobMatch.assessmentDetails.assessmentLinkStatus == 'Complete' && !_.isNull(jobMatch.assessmentDetails.completedDateTime)) {
                jobMatch.previousStateDateTime = jobMatch.assessmentDetails.completedDateTime;
            }
            else if (jobMatch.jobMatchData.jobMatchCurrentState.includes('Failed') && !_.isNull(jobMatch.assessmentDetails.sentDateTime)) {
                jobMatch.previousStateDateTime = jobMatch.assessmentDetails.sentDateTime;
            }
            else {
                jobMatch.previousStateDateTime = '';
            }
            jobMatch.assessmentDetails.sendAssessmentsCount = jobMatch.assessmentDetails.sendAssessmentsCount + 1;
            jobMatch.assessmentDetails = this._setSentAssessmentsPostfix(jobMatch.assessmentDetails);
            jobMatch.message = "";
            let htmlMessage = "Resending Assessment ";
            if (jobMatch.assessmentDetails.assessmentLinkStatus == "Cancelled") {
                htmlMessage = htmlMessage + "as it was previously Canceled on '" + this.$filter('fourdotfiveTimeStampFormat')(jobMatch.assessmentDetails.cancelledDateTime) + "'";
            }
            else if (jobMatch.assessmentDetails.assessmentLinkStatus == 'Expired' || jobMatch.assessmentDetails.assessmentLinkStatus == 'Suspended' || jobMatch.assessmentDetails.assessmentLinkStatus == 'Test Left' || jobMatch.assessmentDetails.assessmentLinkStatus == 'Terminated') {
                htmlMessage = htmlMessage + "as it is in " + jobMatch.assessmentDetails.assessmentLinkStatus + " status. The Assessment was sent on '" + this.$filter('fourdotfiveTimeStampFormat')(jobMatch.assessmentDetails.sentDateTime) + "' and  '" + jobMatch.assessmentDetails.assessmentLinkStatus + "' on '" + this.$filter('fourdotfiveTimeStampFormat')(jobMatch.previousStateDateTime) + "'";
            }
            else if (jobMatch.assessmentDetails.assessmentLinkStatus == 'Complete') {
                htmlMessage = htmlMessage + " as it was previously Completed. The Assessment was sent on '" + this.$filter('fourdotfiveTimeStampFormat')(jobMatch.assessmentDetails.sentDateTime) + "' and was Completed on '" + this.$filter('fourdotfiveTimeStampFormat')(jobMatch.previousStateDateTime) + "'";
            }
            else if (jobMatch.assessmentDetails.isSendAssessmentFailed) {
                htmlMessage = htmlMessage + "as the previous attempt to send failed on '" + this.$filter('fourdotfiveTimeStampFormat')(jobMatch.assessmentDetails.sentDateTime) + "'";
            }
            jobMatch.message = jobMatch.message + htmlMessage;
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _setSentAssessmentsPostfix(assessmentDetails) {
        assessmentDetails.sendAssessmentsCountDisplayValue = "";
        if (assessmentDetails.sendAssessmentsCount == 1) {
            assessmentDetails.sendAssessmentsCountDisplayValue = "1st";
        }
        else if (assessmentDetails.sendAssessmentsCount == 2) {
            assessmentDetails.sendAssessmentsCountDisplayValue = "2nd";
        }
        else if (assessmentDetails.sendAssessmentsCount == 3) {
            assessmentDetails.sendAssessmentsCountDisplayValue = "3rd";
        }
        else {
            assessmentDetails.sendAssessmentsCountDisplayValue = assessmentDetails.sendAssessmentsCount + "th";
        }
        return assessmentDetails;
    }
    getCompanyState(successCallback) {
        if (this.isStaffingCompany && this.isSharedRequisition) {
            this.companyService.getCompanyDetails(this.corporateId, (data) => {
                this.isCompanyOnSoftHold = data.companyState == 'SoftHold' ? true : false;
                successCallback();
            }, (error) => {
                this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
            });
        }
        else {
            this.isCompanyOnSoftHold = this.$rootScope.userDetails.company.companyState == 'SoftHold' ? true : false;
            successCallback();
        }
    }
    getCompanyPlanDetails(successCallback) {
        let getPlanOfCompanyId = this.companyId;
        if (this.isStaffingCompany && this.isSharedRequisition) {
            getPlanOfCompanyId = this.corporateId;
        }
        this.planService.getCompanyPlanDetails(getPlanOfCompanyId, (data) => {
            if (!_.isNull(data)) {
                this.isTrialPlanActive = data.plan == "Trial" ? true : false;
            }
            successCallback();
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    getAvailableAssessments() {
        this.planService.getAvailableTechAssessmentsCount(this.companyId, this.candidateJobMatch.jobMatchJobId, (data) => {
            this.assessmentsLeft = data["techAssessmentsLeft"];
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    sendAssessment() {
        if (!this.sendAssessmentForm.$invalid && !this.reminderErrorFlag) {
            this.savingFlag = true;
            let assessmentDataForSave = angular.copy(this.assessmentData);
            if (this.assessmentData.accessTime == 'anyTime') {
                assessmentDataForSave.startDateTime = null;
                assessmentDataForSave.endDateTime = null;
            }
            else if (this.assessmentData.accessTime == 'timeBound') {
                assessmentDataForSave.startDateTime = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(this.timeBoundStartDate + ' ' + this.timeBoundStartTime));
                assessmentDataForSave.endDateTime = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(this.timeBoundEndDate + ' ' + this.timeBoundEndTime));
            }
            else if (this.assessmentData.accessTime == 'slotWise') {
                assessmentDataForSave.startDateTime = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(this.slotWiseStartDate + ' ' + this.slotWiseStartTime));
                assessmentDataForSave.endDateTime = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date(this.slotWiseEndDate + ' ' + this.slotWiseEndTime));
            }
            assessmentDataForSave.sentDateTime = this.dateTimeUtilityService.getDateTimeInAPIFormat(new Date());
            if (this.assessmentSendMode == 'send') {
                if (this.multipleJobMatchesFlag) {
                    assessmentDataForSave.jobMatchIds = this.jobMatchesThatCanBeSentAssessment.map((jobMatch) => {
                        return jobMatch.jobMatchId;
                    });
                    delete assessmentDataForSave.jobMatchId;
                    this.candidateService.sendAssessments(this.assessmentType, assessmentDataForSave, (sendResultsArray) => {
                        this.savingFlag = false;
                        let sendAssessmentResultsModal = this.$uibModal.open({
                            animation: true,
                            ariaLabelledBy: 'modal-title',
                            ariaDescribedBy: 'modal-body',
                            backdrop: 'static',
                            keyboard: false,
                            windowTopClass: 'four-dot-five-modal-medium',
                            component: 'sendAssessmentResultsModal',
                            resolve: {
                                jobMatchDetailsArray: () => {
                                    return this.jobMatchesThatCanBeSentAssessment;
                                },
                                sendResultsArray: () => {
                                    return sendResultsArray;
                                }
                            }
                        });
                        sendAssessmentResultsModal.result.then(callbackObject => {
                            if (callbackObject.callbackType == 'close' && !_.isUndefined(this.saveCallback)) {
                                this.saveCallback();
                            }
                        }, dismiss => {
                            //do nothing
                        });
                    }, (error) => {
                        this.savingFlag = false;
                        this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                    });
                }
                else {
                    this.jobMatchService.sendAssessment(this.assessmentType, assessmentDataForSave, (data) => {
                        this.savingFlag = false;
                        if (!_.isUndefined(this.saveCallback)) {
                            this.saveCallback();
                        }
                    }, (error) => {
                        this.savingFlag = false;
                        if (this.$rootScope.isOnline) {
                            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                        }
                    });
                }
            }
            else {
                assessmentDataForSave.testType = this.assessmentType;
                this.jobMatchService.resendAssessment(assessmentDataForSave, (data) => {
                    this.savingFlag = false;
                    if (!_.isUndefined(this.saveCallback)) {
                        this.saveCallback();
                    }
                }, (error) => {
                    this.savingFlag = false;
                    this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
                });
            }
        }
    }
    getCandidateJobMatchCardInfo(jobMatchId, successCallback) {
        this.jobMatchService.getCandidateJobMatchCard(jobMatchId, this.companyId, (data) => {
            angular.merge(this.candidateJobMatch, data);
            this.candidateJobMatch = this._massageCandidateJobMatchData(this.candidateJobMatch);
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    _massageCandidateJobMatchData(candidateJobMatch) {
        candidateJobMatch.name = candidateJobMatch.firstName + ' ' + candidateJobMatch.lastName;
        if (candidateJobMatch.jobMatchRequisitionNum == null) {
            candidateJobMatch.jobMatchRequisitionNum = '-';
        }
        this.assessmentName = this.assessmentType == 'Technical' ? candidateJobMatch.techAssessmentName : candidateJobMatch.valueAssessmentName;
        return candidateJobMatch;
    }
    getAccessTimePreferences(successCallback) {
        this.jobService.getAssessmentAccessTime(this.candidateJobMatch.jobMatchJobId, this.sendAssessmentLicensePreferenceEnum, (data) => {
            this.accessTimePreferences = data;
            if (successCallback) {
                successCallback();
            }
        }, (error) => {
            this.alertsAndNotificationsService.showBannerMessage(error.message, 'danger');
        });
    }
    accessTimeTypeChanged() {
        // make sure the latest time is shown in the chosen access time option according to the chosen time zone.
        this.timeZoneChanged();
    }
    reminderChanged() {
        if (this.isReminderEnabled && this.assessmentData.reminder == 0) {
            this.assessmentData.reminder = 1;
        }
        if (this.assessmentData.accessTime == 'timeBound' || this.assessmentData.accessTime == 'slotWise') {
            let currentStartDateTime;
            let momentOfCurrentStartDateTime;
            let currentEndDateTime;
            let momentOfCurrentEndDateTime;
            if (this.assessmentData.accessTime == 'timeBound') {
                currentStartDateTime = new Date(this.timeBoundStartDate + ' ' + this.timeBoundStartTime);
                momentOfCurrentStartDateTime = this.moment(currentStartDateTime);
                currentEndDateTime = new Date(this.timeBoundEndDate + ' ' + this.timeBoundEndTime);
                momentOfCurrentEndDateTime = this.moment(currentEndDateTime);
            }
            else {
                momentOfCurrentStartDateTime = this.moment(new Date(this.slotWiseStartDate));
                momentOfCurrentEndDateTime = this.moment(new Date(this.slotWiseEndDate));
            }
            let differenceInDays = momentOfCurrentEndDateTime.diff(momentOfCurrentStartDateTime, 'days', true);
            if (this.assessmentData.reminder >= differenceInDays && this.isReminderEnabled) {
                this.reminderErrorFlag = true;
            }
            else {
                this.reminderErrorFlag = false;
            }
        }
    }
    timeZoneChanged() {
        if (this.assessmentData.accessTime == 'timeBound') {
            let currentDateTimeStringInSelectedTimeZone = this.moment().tz(this.assessmentData.timeZoneName).format("YYYY-MM-DDTHH:mm:ss.SSS");
            let currentDate = new Date(currentDateTimeStringInSelectedTimeZone);
            let momentOfCurrentDate = this.moment(currentDate);
            let remainderWithClosestQuarter = momentOfCurrentDate.minute() % 15;
            let momentOfCurrentDateTimeFlooredToClosetQuarter = this.moment(momentOfCurrentDate).subtract(remainderWithClosestQuarter, 'm');
            let momentOfDefaultEndDateTime = this.moment(momentOfCurrentDateTimeFlooredToClosetQuarter).add(this.accessTimePreferences.timeToComplete, 'd');
            $("#timeBoundStartDate").datepicker("setDate", momentOfCurrentDateTimeFlooredToClosetQuarter.toDate());
            $("#timeBoundStartDate").datepicker("setStartDate", momentOfCurrentDateTimeFlooredToClosetQuarter.toDate());
            $("#timeBoundStartDate").datepicker("update", this.$filter('fourdotfiveDateFormat')(momentOfCurrentDateTimeFlooredToClosetQuarter.toDate()));
            $("#timeBoundEndDate").datepicker("setDate", momentOfDefaultEndDateTime.toDate());
            // allowed start date on the calendar of end date should still be the same as start date.
            $("#timeBoundEndDate").datepicker("setStartDate", momentOfCurrentDateTimeFlooredToClosetQuarter.toDate());
            $("#timeBoundEndDate").datepicker("update", this.$filter('fourdotfiveDateFormat')(momentOfDefaultEndDateTime.toDate()));
            $("#timeBoundStartTime").timepicker("setTime", this._getTimeStringInAMPMFormat(momentOfCurrentDateTimeFlooredToClosetQuarter.toDate()));
            $('#timeBoundEndTime').timepicker("setTime", "11:59 PM");
            // trigger a reminder change to check if remind after days is in bound
            this.reminderChanged();
        }
        else if (this.assessmentData.accessTime == 'slotWise') {
            let currentDateTimeStringInSelectedTimeZone = this.moment().tz(this.assessmentData.timeZoneName).format("YYYY-MM-DDTHH:mm:ss.SSS");
            let currentDate = new Date(currentDateTimeStringInSelectedTimeZone);
            let momentOfDefaultEndDateTime = this.moment(currentDate).add(this.accessTimePreferences.timeToComplete, 'd');
            $("#slotWiseStartDate").datepicker("setDate", currentDate);
            $("#slotWiseStartDate").datepicker("setStartDate", currentDate);
            $("#slotWiseStartDate").datepicker("update", this.$filter('fourdotfiveDateFormat')(currentDate));
            $("#slotWiseEndDate").datepicker("setDate", momentOfDefaultEndDateTime.toDate());
            // allowed start date on the calendar of end date should still be the same as start date.
            $("#slotWiseEndDate").datepicker("setStartDate", currentDate);
            $("#slotWiseEndDate").datepicker("update", this.$filter('fourdotfiveDateFormat')(momentOfDefaultEndDateTime.toDate()));
            $("#slotWiseStartTime").timepicker("setTime", "09:00 AM");
            $('#slotWiseEndTime').timepicker("setTime", "12:00 PM");
            // trigger a reminder change to check if remind after days is in bound
            this.reminderChanged();
        }
    }
    _initializeDateAndTimePickersForTimeBound() {
        $(document).ready(() => {
            let currentDateTimeStringInSelectedTimeZone = this.moment().tz(this.assessmentData.timeZoneName).format("YYYY-MM-DDTHH:mm:ss.SSS");
            let currentDate = new Date(currentDateTimeStringInSelectedTimeZone);
            let momentOfCurrentDate = this.moment(currentDate);
            let remainderWithClosestQuarter = momentOfCurrentDate.minute() % 15;
            let momentOfCurrentDateTimeFlooredToClosetQuarter = this.moment(momentOfCurrentDate).subtract(remainderWithClosestQuarter, 'm');
            let momentOfDefaultEndDateTime = this.moment(momentOfCurrentDateTimeFlooredToClosetQuarter).add(this.accessTimePreferences.timeToComplete, 'd');
            $('#timeBoundStartDate').datepicker({
                format: "M d, yyyy",
                startDate: momentOfCurrentDateTimeFlooredToClosetQuarter.toDate(),
                weekStart: 1,
                autoclose: true
            });
            // set current date as default value
            $("#timeBoundStartDate").datepicker("setDate", momentOfCurrentDateTimeFlooredToClosetQuarter.toDate());
            $("#timeBoundStartDate").datepicker("update", this.$filter('fourdotfiveDateFormat')(momentOfCurrentDateTimeFlooredToClosetQuarter.toDate()));
            $('#timeBoundEndDate').datepicker({
                format: "M d, yyyy",
                startDate: momentOfCurrentDateTimeFlooredToClosetQuarter.toDate(),
                weekStart: 1,
                autoclose: true
            });
            $("#timeBoundEndDate").datepicker("setDate", momentOfDefaultEndDateTime.toDate());
            $("#timeBoundEndDate").datepicker("update", this.$filter('fourdotfiveDateFormat')(momentOfDefaultEndDateTime.toDate()));
            $('#timeBoundStartTime').timepicker({
                minuteStep: 5,
                showSeconds: false,
                showMeridian: true,
                disableFocus: true,
                defaultTime: this._getTimeStringInAMPMFormat(momentOfCurrentDateTimeFlooredToClosetQuarter.toDate())
            });
            $('#timeBoundEndTime').timepicker({
                minuteStep: 5,
                showSeconds: false,
                showMeridian: true,
                disableFocus: true,
                defaultTime: '11:59 PM'
            });
            $('#timeBoundStartDate').datepicker().on('changeDate', (e) => {
                this._validateAndCorrectStartDateTimeAndEndDateTimeForTimeBound();
                this.$timeout(() => {
                    // trigger a reminder change to check if remind after days is in bound
                    this.reminderChanged();
                }, 100);
            });
            $('#timeBoundEndDate').datepicker().on('changeDate', (e) => {
                this._validateAndCorrectStartDateTimeAndEndDateTimeForTimeBound();
                this.$timeout(() => {
                    // trigger a reminder change to check if remind after days is in bound
                    this.reminderChanged();
                }, 100);
            });
            $('#timeBoundStartTime').timepicker().on('changeTime.timepicker', (e) => {
                this._validateAndCorrectStartDateTimeAndEndDateTimeForTimeBound();
                this.$timeout(() => {
                    // trigger a reminder change to check if remind after days is in bound
                    this.reminderChanged();
                }, 100);
            });
            $('#timeBoundEndTime').timepicker().on('changeTime.timepicker', (e) => {
                this._validateAndCorrectStartDateTimeAndEndDateTimeForTimeBound();
                this.$timeout(() => {
                    // trigger a reminder change to check if remind after days is in bound
                    this.reminderChanged();
                }, 100);
            });
        });
    }
    _initializeDateAndTimePickersForSlotWise() {
        $(document).ready(() => {
            let currentDateTimeStringInSelectedTimeZone = this.moment().tz(this.assessmentData.timeZoneName).format("YYYY-MM-DDTHH:mm:ss.SSS");
            let currentDate = new Date(currentDateTimeStringInSelectedTimeZone);
            let momentOfDefaultEndDateTime = this.moment(currentDate).add(this.accessTimePreferences.timeToComplete, 'd');
            $('#slotWiseStartDate').datepicker({
                format: "M d, yyyy",
                startDate: currentDate,
                weekStart: 1,
                autoclose: true
            });
            // set current date as default value
            $("#slotWiseStartDate").datepicker("setDate", currentDate);
            $("#slotWiseStartDate").datepicker("update", this.$filter('fourdotfiveDateFormat')(currentDate));
            $('#slotWiseEndDate').datepicker({
                format: "M d, yyyy",
                startDate: currentDate,
                weekStart: 1,
                autoclose: true
            });
            $("#slotWiseEndDate").datepicker("setDate", momentOfDefaultEndDateTime.toDate());
            $("#slotWiseEndDate").datepicker("update", this.$filter('fourdotfiveDateFormat')(momentOfDefaultEndDateTime.toDate()));
            $('#slotWiseStartTime').timepicker({
                minuteStep: 5,
                showSeconds: false,
                showMeridian: true,
                disableFocus: true,
                defaultTime: '09:00 AM'
            });
            $('#slotWiseEndTime').timepicker({
                minuteStep: 5,
                showSeconds: false,
                showMeridian: true,
                disableFocus: true,
                defaultTime: '12:00 PM'
            });
            $('#slotWiseStartDate').datepicker().on('changeDate', (e) => {
                this._validateAndCorrectStartDateAndEndDateForSlotWise();
                this.$timeout(() => {
                    // trigger a reminder change to check if remind after days is in bound
                    this.reminderChanged();
                }, 100);
            });
            $('#slotWiseEndDate').datepicker().on('changeDate', (e) => {
                this._validateAndCorrectStartDateAndEndDateForSlotWise();
                this.$timeout(() => {
                    // trigger a reminder change to check if remind after days is in bound
                    this.reminderChanged();
                }, 100);
            });
            $('#slotWiseStartTime').timepicker().on('changeTime.timepicker', (e) => {
                this._validateAndCorrectStartTimeAndEndTimeForSlotWise();
            });
            $('#slotWiseEndTime').timepicker().on('changeTime.timepicker', (e) => {
                this._validateAndCorrectStartTimeAndEndTimeForSlotWise();
            });
        });
    }
    _getTimeStringInAMPMFormat(date) {
        return this.moment(date).format("hh:mm A");
    }
    _validateAndCorrectStartDateTimeAndEndDateTimeForTimeBound() {
        let currentDateTimeStringInSelectedTimeZone = this.moment().tz(this.assessmentData.timeZoneName).format("YYYY-MM-DDTHH:mm:ss.SSS");
        let momentOfCurrentDateTime = this.moment(currentDateTimeStringInSelectedTimeZone);
        let currentStartDateTime = new Date(this.timeBoundStartDate + ' ' + this.timeBoundStartTime);
        let momentOfCurrentStartDateTime = this.moment(currentStartDateTime);
        let currentEndDateTime = new Date(this.timeBoundEndDate + ' ' + this.timeBoundEndTime);
        // if the start date is same as the current date
        let startDateAndCurrentDateAreSameFlag = momentOfCurrentStartDateTime.isSame(momentOfCurrentDateTime, 'day');
        // if the start hours are less than current hours
        let startHoursLessThanCurrentHoursFlag = momentOfCurrentStartDateTime.isBefore(momentOfCurrentDateTime, 'hour');
        let remainderWithClosestQuarter = momentOfCurrentDateTime.minute() % 15;
        let currentDateTimeFlooredToClosetQuarter = momentOfCurrentDateTime.subtract(remainderWithClosestQuarter, 'm').toDate();
        // if the hours are equal but minutes are less than current date time floored to closest quarter minutes.
        let hoursEqualButStartMinutesLessThanCurrentMinutesFlag = (momentOfCurrentStartDateTime.isSame(momentOfCurrentDateTime, 'hour') && momentOfCurrentStartDateTime.isBefore(currentDateTimeFlooredToClosetQuarter, 'minute'));
        if (startDateAndCurrentDateAreSameFlag && (startHoursLessThanCurrentHoursFlag || hoursEqualButStartMinutesLessThanCurrentMinutesFlag)) {
            $("#timeBoundStartTime").timepicker("setTime", this._getTimeStringInAMPMFormat(currentDateTimeFlooredToClosetQuarter));
        }
        else if (currentStartDateTime >= currentEndDateTime) {
            // after the change to 'start time', check if the existing 'end time' component keeps 'end date time' as greater than 'start date time'
            // if not, make the 'end date time' as 'time to complete' days greater than currentStartDateTime
            let defaultEndDateTime = this.moment(currentStartDateTime).add(this.accessTimePreferences.timeToComplete, 'd').toDate();
            $("#timeBoundEndDate").datepicker("setDate", defaultEndDateTime);
            $("#timeBoundEndDate").datepicker("update", this.$filter('fourdotfiveDateFormat')(defaultEndDateTime));
            $('#timeBoundEndTime').timepicker("setTime", '11:59 PM');
        }
        // set start date of end date calendar to be current start date
        $("#timeBoundEndDate").datepicker("setStartDate", currentStartDateTime);
    }
    _validateAndCorrectStartDateAndEndDateForSlotWise() {
        let momentOfCurrentStartDate = this.moment(new Date(this.slotWiseStartDate));
        let momentOfCurrentEndDate = this.moment(new Date(this.slotWiseEndDate));
        if (momentOfCurrentEndDate.isBefore(momentOfCurrentStartDate, 'day')) {
            // make the 'end date' as 'time to complete' days greater than 'start date'
            let defaultEndDate = momentOfCurrentStartDate.add(this.accessTimePreferences.timeToComplete, 'd').toDate();
            $("#slotWiseEndDate").datepicker("setDate", defaultEndDate);
            $("#slotWiseEndDate").datepicker("update", this.$filter('fourdotfiveDateFormat')(defaultEndDate));
        }
        // set start date of end date calendar to be current start date
        $("#slotWiseEndDate").datepicker("setStartDate", momentOfCurrentStartDate.toDate());
    }
    _validateAndCorrectStartTimeAndEndTimeForSlotWise() {
        // use start date for the date part. Otherwise we can't parse date.
        let momentOfCurrentStartTime = this.moment(new Date(this.slotWiseStartDate + " " + this.slotWiseStartTime));
        let momentOfCurrentEndTime = this.moment(new Date(this.slotWiseStartDate + " " + this.slotWiseEndTime));
        if (momentOfCurrentEndTime.isBefore(momentOfCurrentStartTime)) {
            // make the 'end time' as 1 hour greater than 'start time'
            let defaultEndTime = momentOfCurrentStartTime.add(1, 'h').toDate();
            $('#slotWiseEndTime').timepicker("setTime", this._getTimeStringInAMPMFormat(defaultEndTime));
        }
    }
    onInternalNoteChanged() {
        this.assessmentData.externalNote = this.assessmentData.notes;
    }
    onExternalNoteChange(event) {
        this.assessmentData.externalNote = event.externalNote;
    }
    onCopyNoteChange(event) {
        this.copyNote = event.copyNote;
    }
    receiveFormalizedComment(event) {
        this.assessmentData.notes = event;
        this.onInternalNoteChanged();
    }
    onVoiceTranscript(transcript) {
        if (this.assessmentData.notes) {
            this.assessmentData.notes += ' ' + transcript;
        }
        else {
            this.assessmentData.notes = transcript;
        }
        this.onInternalNoteChanged();
    }
    reminderEnabledOrDisabled() {
        if (!this.isReminderEnabled) {
            this.assessmentData.reminder = 0;
            this.reminderErrorFlag = false;
        }
        else {
            this.assessmentData.reminder = this.defaultReminderInterval;
            this.reminderChanged();
        }
    }
}
SendAssessmentController.$inject = ['$rootScope', '$uibModal', '$timeout', '$filter', 'moment', 'dateTimeUtilityService', 'jobMatchService', 'jobService', 'assessmentService', 'planService', 'candidateService', 'companyService', 'alertsAndNotificationsService'];
// import * as TEMPLATE from './send-assessment.html;
import * as TEMPLATE from 'raw-loader!./send-assessment.html';
export const SendAssessmentComponent = {
    selector: 'sendAssessment',
    component: {
        bindings: {
            jobMatchId: '@',
            jobMatchDetailsArrayString: '@',
            candidateId: '@',
            assessmentType: '@',
            assessmentSendMode: '@',
            notes: '@',
            corporateId: '@',
            corporateName: '@',
            buName: '@',
            isSharedRequisition: '<',
            saveCallback: '&',
            sourceScreen: '@',
            formalizeActivityPayload: '<'
        },
        controller: SendAssessmentController,
        // templateUrl: 'app/shared/jobMatchActions/sendAssessment/send-assessment.html'
        template: TEMPLATE.default
    }
};
//# sourceMappingURL=send-assessment.component.js.map